import {
  Injectable,
  isDevMode,
  type EnvironmentProviders,
} from '@angular/core';
import {
  provideTransloco,
  type Translation,
  type TranslocoLoader,
} from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { from, type Observable } from 'rxjs';
import {
  COMMO_DEFAULT_LANGUAGE,
  COMMO_SUPPORTED_LANGUAGES,
} from './supported-languages';

@Injectable({ providedIn: 'root' })
class TranslocoAssetsLoader implements TranslocoLoader {
  getTranslation(lang: string): Observable<Translation> {
    return from(
      fetch(`/i18n/${lang}.json`).then(async (res) => {
        if (!res.ok) {
          throw new Error(`Failed to load i18n/${lang}.json (${res.status})`);
        }
        return (await res.json()) as Translation;
      }),
    );
  }
}

export function provideCommoI18n(): EnvironmentProviders[] {
  return [
    ...provideTransloco({
      config: {
        availableLangs: [...COMMO_SUPPORTED_LANGUAGES],
        defaultLang: COMMO_DEFAULT_LANGUAGE,
        fallbackLang: COMMO_DEFAULT_LANGUAGE,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          useFallbackTranslation: true,
          /** 開発時のみ欠損キーをログ（英語フォールバックは fallbackLang）。 */
          logMissingKey: isDevMode(),
        },
      },
      loader: TranslocoAssetsLoader,
    }),
    provideTranslocoMessageformat({
      locales: [...COMMO_SUPPORTED_LANGUAGES],
    }),
  ];
}
